import request from '@/utils/request'; // 获取列表

export function fetchManageList(data) {
  return request({
    url: '/whg-park/api/noticeInfo/list',
    method: 'post',
    data: data
  });
} // 添加

export function fetchCreate(data) {
  return request({
    url: '/whg-park/api/noticeInfo/insert',
    method: 'post',
    data: data
  });
} // 详情

export function fetchDetail(data) {
  return request({
    url: '/whg-park/api/noticeInfo/get',
    method: 'post',
    data: data
  });
} // 删除

export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/whg-park/api/noticeInfo/delete',
    method: 'post',
    data: data
  });
} // 编辑

export function fetchUpdate(data) {
  return request({
    url: '/whg-park/api/noticeInfo/update',
    method: 'post',
    data: data
  });
}
export function fetchClassList(data) {
  return request({
    url: '/whg-park/api/noticeInfo/update',
    method: 'post',
    data: data
  });
}
export function fetchDetailForManage(data) {
  return request({
    url: '/whg-park/api/noticeInfo/update',
    method: 'post',
    data: data
  });
}
export function fetchReadList(data) {
  return request({
    url: '/whg-park/api/noticeInfo/readerList',
    method: 'post',
    data: data
  });
} // 发送短信

export function sendSms(data) {
  return request({
    url: '/pmsexternal/open/sync/softWorkerSms/sendSms',
    method: 'post',
    data: data
  });
}